// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"e8701a48","209":"e1f55257","453":"9c92393f","478":"241c5713","495":"002b0b42","787":"2279df3c","922":"a9748d02"}[chunkId] + ".chunk.js";
};